import React, { memo } from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: '1',
  title: 'El Despertar de la Hija Pródiga',
  emoji: '📘',
  desc: 'El primer paso del camino. Cómo reconocer las lealtades invisibles que organizan tu vida sin que lo sepas. El mapa completo de las dinámicas que heredaste y que todavía operan en vos hoy.'
}, {
  num: '2',
  title: 'El Espejo de la Madre',
  emoji: '📗',
  desc: 'La relación más determinante de tu vida. Cómo la dinámica con tu madre moldeó tu autoestima, tu capacidad de recibir y tu relación con el cuerpo. Protocolo de sanación del vínculo materno.'
}, {
  num: '3',
  title: 'La Sombra del Linaje Femenino',
  emoji: '📙',
  desc: 'Las mujeres que vinieron antes que vos. Sus heridas. Sus silencios. Sus sueños no vividos. Cómo esas memorias biológicas operan en tu cuerpo y en tus decisiones hoy. Ritual de honor y liberación.'
}, {
  num: '4',
  title: 'El Padre y el Permiso de Brillar',
  emoji: '📕',
  desc: 'El origen del techo de cristal genealógico. Cómo la relación con tu padre determina tu permiso de éxito, visibilidad y abundancia. Protocolo de recuperación del permiso que nunca te dieron.'
}, {
  num: '5',
  title: 'Cirugía del Árbol Genealógico',
  emoji: '📓',
  desc: 'El trabajo profundo de mapeo y liberación. Cómo leer tu árbol genealógico en 30 minutos. Identificar patrones de dinero, amor y salud. Protocolo de corte de lealtades que ya cumplieron su función.'
}, {
  num: '6',
  title: 'La Nueva Matriarca',
  emoji: '📔',
  desc: 'El tomo de integración y consolidación. Cómo construir una identidad nueva que no dependa del permiso del sistema familiar. Tu protocolo personal de soberanía. El cierre del ciclo y la apertura de uno nuevo.'
}];
export function HowItWorksSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1C1410] py-12 md:py-16 px-5 sm:px-6 border-t border-[#C9A96E]/10" data-id="element-171">
      <div className="container mx-auto max-w-4xl" data-id="element-172">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-173">
          <h2 className="text-3xl md:text-5xl font-bold text-[#F5ECD7] mb-3" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-174">
            🌹 6 TOMOS COMPLETOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-175">
          {TOMOS.map((tomo, idx) => <div key={idx} className="bg-[#2D1B1B] border border-[#C9A96E]/20 rounded-xl p-5 sm:p-6 flex flex-col h-full hover:border-[#C9A96E]/50 transition-colors shadow-lg" data-id="element-176">
              <div className="flex items-start gap-3 mb-3" data-id="element-177">
                <span className="text-3xl leading-none" data-id="element-178">{tomo.emoji}</span>
                <div data-id="element-179">
                  <span className="text-[#C9A96E] text-[10px] font-bold tracking-widest uppercase block mb-1" data-id="element-180">
                    Tomo {tomo.num}
                  </span>
                  <h3 className="text-lg font-bold text-[#F5ECD7] leading-tight" data-id="element-181">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <p className="text-[#FAF3E8] text-sm leading-relaxed mt-2" data-id="element-182">
                {tomo.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-10 bg-[#2D1B1B] border border-[#C9A96E]/20 rounded-xl p-6 text-center max-w-2xl mx-auto shadow-lg" data-id="element-183">
          <p className="text-[#F5ECD7] font-bold mb-4" data-id="element-184">Cada tomo incluye:</p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-[#FAF3E8]" data-id="element-185">
            <span className="flex items-center gap-1.5" data-id="element-186">
              <span className="text-[#C9A96E]" data-id="element-187">✅</span> Protocolos paso a paso
            </span>
            <span className="flex items-center gap-1.5" data-id="element-188">
              <span className="text-[#C9A96E]" data-id="element-189">✅</span> Ejercicios de
              integración
            </span>
            <span className="flex items-center gap-1.5" data-id="element-190">
              <span className="text-[#C9A96E]" data-id="element-191">✅</span> Scripts de liberación
            </span>
            <span className="flex items-center gap-1.5" data-id="element-192">
              <span className="text-[#C9A96E]" data-id="element-193">✅</span> Rituales prácticos
            </span>
            <span className="flex items-center gap-1.5" data-id="element-194">
              <span className="text-[#C9A96E]" data-id="element-195">✅</span> Tests de
              autodiagnóstico
            </span>
            <span className="flex items-center gap-1.5" data-id="element-196">
              <span className="text-[#C9A96E]" data-id="element-197">✅</span> Contexto argentino y
              rioplatense
            </span>
          </div>
        </div>
      </div>
    </section>;
}